import { type CanvasElement, type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputListFiltersModel } from '@blaze-shared/elements-domain';

import { isElementType } from '../../canvas-elements/element-model/element-type-guards';
import { type SearchAndFiltersWrapperService } from '../../services/search-and-filters-wrapper.service';
import {
  type ContainerFilterContentMode,
  type ContainerFilterType,
  toContainerFilterType,
} from '../models';

export interface ResolveFilterTypeOptions {
  searchAndFiltersWrapperService: SearchAndFiltersWrapperService;
  containerElementId: CanvasElementId;
  filter: PropertiesConfigInputListFiltersModel;
}

export function resolveFilterType({
  searchAndFiltersWrapperService,
  containerElementId,
  filter,
}: ResolveFilterTypeOptions): ContainerFilterType | undefined {
  const filterElement = searchAndFiltersWrapperService.getFilterControlElement(
    containerElementId,
    filter.id,
  );
  if (!filterElement) {
    return undefined;
  }

  return toContainerFilterType({
    elementType: filterElement.type,
    contentMode: getChipContentMode(filterElement),
    filterOperatorType: filter.filterOperatorType,
  });
}

function getChipContentMode(element: CanvasElement): ContainerFilterContentMode | undefined {
  const isChipCapable = isElementType(element, 'radio') || isElementType(element, 'checkbox');
  return isChipCapable && element.props.content?.mode === 'chip' ? 'chip' : undefined;
}
